import request from '@/utils/service'
import downloadService from '@/utils/download'

export function addPartnerApi(data) {
  return request({
    url: '/partner/add',
    method: 'post',
    data
  })
}

export function updatePartnerApi(data) {
  return request({
    url: '/partner/update',
    method: 'post',
    data
  })
}

export function parentsStatusApi(data) {
  return request({
    url: '/partner/updateStatus',
    method: 'post',
    data
  })
}

export function delPartnerApi(data) {
  return request({
    url: '/partner/delete',
    method: 'post',
    data
  })
}

export function partnersListApi(data) {
  console.log('params :>> ', data)
  return request({
    url: '/partner/list',
    method: 'get',
    params: data
  })
}

export function partnersDetailApi(data) {
  return request({
    url: '/partner/detail',
    method: 'get',
    params: data
  })
}


export function partnersLevelApi(key) {
  return request({
    url: `/setting/detail/${key}`,
    method: 'get',
    params: {}
  })
}

export function partnersEquApi(data) {
  return request({
    url: '/partner/devices',
    method: 'get',
    params: data
  })
}

export function partnerRechargeOrder(data) {
  return request({
    url: '/xdWalletTxFlow/recharge/flow',
    method: 'get',
    params: data
  })
}

// 合伙人钱包明细
export function xdWalletTxFlowApi(data) {
  return request({
    url: '/xdWalletTxFlow/list',
    method: 'get',
    params: data
  })
}

// 钱包流水统计
export function walletStatisticsApi(code) {
  return request({
    url: `/partner/statistics/${code}`,
    method: 'get'
  })
}

// 合伙人注册管理
export function partnerRegisterListApi(data) {
  return request({
    url: '/partnerRegisterInfo/list',
    method: 'post',
    params: data
  })
}

// 合伙人-充电订单列表
export function findChargePieOrderList(data) {
  return request({
    url: '/partner/findChargePieOrderList',
    method: 'post',
    params: data
  })
}

// 合伙人- 套餐卡订单列表
export function partnerPackageOrderList(data) {
  return request({
    url: '/partner/packageOrderList',
    method: 'post',
    params: data
  })
}

// 合伙人-小区列表
export function partnerCommunityListApi(data) {
  return request({
    url: '/partner/residentialAreaList',
    method: 'post',
    params: data
  })
}

// 合伙人-充电订单导出
export function partnerChargeOrderExport(data) {
  return downloadService({
    url: '/partner/chargeOrderExport',
    method: 'post',
    data
  })
}

// 合伙人-充值订单流水导出
export function partnerXdWalletTxFlowExport(data) {
  return downloadService({
    url: '/xdWalletTxFlow/rechargeFlowExport',
    method: 'post',
    data
  })
}

// 合伙人-合伙人钱包导出
export function partnerPayExport(data) {
  return downloadService({
    url: '/xdWalletTxFlow/export',
    method: 'post',
    data
  })
}

// 合伙人-套餐卡订单导出
export function partnerPackageOrderExport(data) {
  return downloadService({
    url: '/partner/packageOrderExport',
    method: 'post',
    data
  })
}

